import React, { useContext, useState, Suspense, lazy } from 'react';
import { FiMessageCircle } from 'react-icons/fi';
import { UserContext } from '../App';
import { Link } from 'react-router-dom';
const Comments = lazy(() => import('./Comments'));
export default function CommentModalController({ post_id, numberOfComments }) {
  const user = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const content = <><FiMessageCircle aria-hidden="true" /><span className="count">{numberOfComments || 0}</span></>;
  return <>{user?.email ? <button type="button" className="rxns" aria-label="Open comments" aria-haspopup="dialog" onClick={() => setOpen(true)}>{content}</button> : <Link className="rxns" aria-label="Sign in to comment" to="/account">{content}</Link>}
    {open && user?.email && <Suspense fallback={<div role="status">Loading comments…</div>}><Comments post_id={post_id} closeCommentsModal={setOpen} /></Suspense>}
  </>;
}
